import { Stack, Typography, useTheme } from "@mui/material";
import { MprcButton } from "components";
import { ConfidenceLevel } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onClick: (confidenceLevel: ConfidenceLevel) => void;
}

export const AssPlayerConfidenceLevel: React.FC<IProps> = (props) => {

    const { onClick } = props;

    const { t } = useTranslation("assessment");
    const theme = useTheme();

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <Stack
            direction="column"
            alignItems="center"
            spacing={1}
            mt={2}
            sx={{
                backgroundColor: theme.palette.notice.main,
                padding: 2,
                borderRadius: "8px",
            }}
        >
            <Typography variant="body2">{t("AssPlayer.Question.ConfidenceLevelText")}</Typography>

            <Stack direction="row" spacing={2}>
                <MprcButton
                    text={t("AssPlayer.Question.ConfidenceLevel.LowButtonText")}
                    title={t("AssPlayer.Question.ConfidenceLevel.LowButtonTitle")}
                    variant="contained"
                    onClick={() => onClick(ConfidenceLevel.Low)}
                />
                <MprcButton
                    text={t("AssPlayer.Question.ConfidenceLevel.MediumButtonText")}
                    title={t("AssPlayer.Question.ConfidenceLevel.MediumButtonTitle")}
                    variant="contained"
                    onClick={() => onClick(ConfidenceLevel.Medium)}
                />
                <MprcButton
                    text={t("AssPlayer.Question.ConfidenceLevel.HighButtonText")}
                    title={t("AssPlayer.Question.ConfidenceLevel.HighButtonTitle")}
                    variant="contained"
                    onClick={() => onClick(ConfidenceLevel.High)}
                />
            </Stack>
        </Stack>
    );
};
